/* src/app/order/translations/translation-field/translation-field.style.scss */
.translation-preview {
  color: rgba(88, 88, 88, 0.7803921569);
  display: flex;
  flex-direction: column;
  font-weight: bold;
}
.translation-preview label {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  font-family: Arial, sans-serif;
  color: #007d40;
  margin-bottom: 5px;
  text-transform: uppercase;
}
:host ::ng-deep .textarea {
  background-color: rgba(204, 204, 204, 0.3098039216) !important;
}
/*# sourceMappingURL=translation-field.style.css.map */
